import React from 'react';
import { createRoot } from 'react-dom/client'
import App from './App';
import * as serviceWorker from './serviceWorker';
import ErrorBoundary from './errorBoundary';
import 'bootstrap/dist/css/bootstrap.css';
import 'underscore/underscore-min';
import './Custom.css';
import './BlockUI.css';
import './assets/fontawesome/css/all.min.css';
import { registerLicense } from '@syncfusion/ej2-base';
import { AccessControlProvider } from './accessControl';

const config = {
    allowedDomains: ['https://bem.betacomservices.com', 'https://erp.global.claims'],
    allowDirectAccess: false, // false in produzione
    debugMode: false, // false in produzione  
    autoRedirect: false // NON reindirizza automaticamente
};

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1JGaF5cX2JCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWX5ecnVVRWJdU0R1WEZWYEs=');

const root = createRoot(document.getElementById('rootElement')); 
root.render(<ErrorBoundary><AccessControlProvider config={config}><App /></AccessControlProvider></ErrorBoundary>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();